import React, { createContext, useContext, useState, useCallback, useRef } from 'react';
import ConfirmModal from '../components/ConfirmModal';

const ConfirmContext = createContext();

export const useConfirm = () => {
  const context = useContext(ConfirmContext);
  if (!context) {
    throw new Error('useConfirm must be used within ConfirmProvider');
  }
  return context;
};

export const ConfirmProvider = ({ children }) => {
  const [modalState, setModalState] = useState({
    isOpen: false,
    title: '',
    message: '',
    confirmText: 'Підтвердити',
    cancelText: 'Скасувати',
    isAlert: false,
    type: 'danger'
  });

  const resolverRef = useRef(null);

  const confirm = useCallback((options = {}) => {
    setModalState({
      isOpen: true,
      title: options.title || 'Підтвердження дії',
      message: options.message || 'Ви впевнені, що хочете виконати цю дію?',
      confirmText: options.confirmText || (options.isAlert ? 'ОК' : 'Підтвердити'),
      cancelText: options.cancelText || 'Скасувати',
      isAlert: !!options.isAlert,
      type: options.type || 'danger'
    });
    return new Promise((resolve) => {
      resolverRef.current = resolve;
    });
  }, []);

  const handleConfirm = useCallback(() => {
    setModalState(prev => ({ ...prev, isOpen: false }));
    if (resolverRef.current) {
      resolverRef.current(true);
    }
  }, []);

  const handleCancel = useCallback(() => {
    setModalState(prev => ({ ...prev, isOpen: false }));
    if (resolverRef.current) {
      resolverRef.current(false);
    }
  }, []);

  return (
    <ConfirmContext.Provider value={confirm}>
      {children}
      <ConfirmModal
        isOpen={modalState.isOpen}
        title={modalState.title}
        message={modalState.message}
        confirmText={modalState.confirmText}
        cancelText={modalState.cancelText}
        isAlert={modalState.isAlert}
        type={modalState.type}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
      />
    </ConfirmContext.Provider>
  );
};
